import { ButtonPrimary } from "components/Atoms/Button";
import Modal, { ModalWidth } from "components/modal";
import React from "react";

interface Props<T extends unknown> {
  buttonLabel: string
  modalTitle: string
  modalSize: ModalWidth
  renderModalContent: (
    editedValue: T[],
    setEditedValue: (value: T[]) => void,
  ) => React.ReactNode
  onClose: () => void
  onSave: (value: T[]) => void
  initialValue: T[]
}

export const ModalForMultiPicker = <T extends unknown>(props: Props<T>) => {
  const [editedValue, setEditedValue] = React.useState<T[]>(props.initialValue);
  return <Modal
    isOpen
    handleClose={props.onClose}
    width={props.modalSize}
    gap="regular"
    title={props.modalTitle}
    height={700}
  >
    {props.renderModalContent(editedValue, setEditedValue)}
    <div className="flex justify-end">
      <div>
        <ButtonPrimary
          fluid
          label={RESX.Buttons.btnSave}
          onClick={() => props.onSave(editedValue)}
        />
      </div>
    </div>
  </Modal>
}